"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_SEND_BOX = void 0;
exports["default"] = setSendBox;
var SET_SEND_BOX = 'WEB_CHAT/SET_SEND_BOX';
exports.SET_SEND_BOX = SET_SEND_BOX;
function setSendBox(text) {
  return {
    type: SET_SEND_BOX,
    payload: {
      text: text
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTRVRfU0VORF9CT1giLCJleHBvcnRzIiwic2V0U2VuZEJveCIsInRleHQiLCJ0eXBlIiwicGF5bG9hZCJdLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3NldFNlbmRCb3guanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgU0VUX1NFTkRfQk9YID0gJ1dFQl9DSEFUL1NFVF9TRU5EX0JPWCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHNldFNlbmRCb3godGV4dCkge1xuICByZXR1cm4ge1xuICAgIHR5cGU6IFNFVF9TRU5EX0JPWCxcbiAgICBwYXlsb2FkOiB7IHRleHQgfVxuICB9O1xufVxuXG5leHBvcnQgeyBTRVRfU0VORF9CT1ggfTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBLElBQU1BLFlBQVksR0FBRyx1QkFBdUI7QUFBQ0MsT0FBQSxDQUFBRCxZQUFBLEdBQUFBLFlBQUE7QUFFOUIsU0FBU0UsVUFBVUEsQ0FBQ0MsSUFBSSxFQUFFO0VBQ3ZDLE9BQU87SUFDTEMsSUFBSSxFQUFFSixZQUFZO0lBQ2xCSyxPQUFPLEVBQUU7TUFBRUYsSUFBSSxFQUFKQTtJQUFLO0VBQ2xCLENBQUM7QUFDSCJ9